import React from 'react'
import TextInput from './form/TextInput'
import MenuButton from "./button/MenuButton";
import CardContainer from './card/CardContainer'
import GlobalStorage from './storage/GlobalStorage'
import { faOtter } from '@fortawesome/free-solid-svg-icons';

function array_move(arr, old_index, new_index) {
  if (new_index >= arr.length) {
    var k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr; // for testing
};

export default class extends React.Component{

  constructor(props)
  {
    super(props);
    this.state = {
      is_ready: false,
    }

    this.items = new GlobalStorage().getStoryEpisodeItems();

    this.toolbox = {
      items: [
        {value: `Scene`, label: `新增分頁`},
        {value: `Narrative`, label: `新增旁白`},
        {value: `Text`, label: `新增對白`},
        {value: `Media`, label: `新增媒體`},
        
      ],
    }
  }

  componentDidMount() {
    this.setState({
      is_ready: true
    });    
  }

  doAction(item)
  {
    new GlobalStorage().addStoryEpisodeItem(item.value);
    this.forceUpdate();
    var itemsDiv = document.getElementById("items");
    itemsDiv.scrollTop = itemsDiv.scrollHeight;
  }

  render()
  {
    return (
        <div style={{position: `relative`, height: `100%`, display: `flex`, flexDirection: `row`}}>
          <div style={{flex: `0 0 120px`, position: `relative`, height: `100%`, textAlign: `center`,
            backgroundColor: '#ddd'}}>

            <h3 style={{padding:`10px 15px 0 15px`,margin:`15px 0`}}>工具</h3>

            {
              this.toolbox.items.map((item, i) => {
                return (
                    <MenuButton                        
                        key={i}
                        onClick={() => {this.doAction(item)}}>
                      {item.label}
                    </MenuButton>
                )
              })
            }

          </div>
          <div style={{flex: `0 0 323px`, position: `relative`, height: `100%`,
            backgroundColor: '#eee', marginLeft:`2px`}}>

            <h3 style={{padding:`10px 15px`,margin:`15px 0`}}>故事時間軸</h3>
            {
              this.state.is_ready ? (
                  <div style={{height: `90%`, overflowY: `scroll`}} id="items">
                    {
                      this.items.map((item, i) => {
                        return (
                            <CardContainer {...this.props}                                           
                                           key={i}
                                           index={i}
                                           item={item}
                                           onSelect={(item) => {
                                             if (item.isSelected)
                                             {
                                               item.isSelected = !item.isSelected;
                                             }
                                             else
                                             {
                                               for (var k = 0; k < this.items.length; k++)
                                               {
                                                 this.items[k].isSelected = false;
                                               }
                                               item.isSelected = true;
                                             }
                                           }}
                                           onRemove={(item) => {
                                             if (window.confirm("確認刪除?"))
                                             {
                                               this.items.splice(i, 1);
                                               this.forceUpdate();
                                             }
                                           }}
                                           onShiftUp={(item) => {
                                             var shift = Number(window.prompt("移上多少格?","1"));
                                             var from = i;
                                             var to = i - shift;
                                             if (to < 0) {
                                               to = 0;
                                             }
                                             array_move(this.items, from, to);
                                             this.forceUpdate();
                                           }}
                                           onShiftDown={(item) => {
                                             var shift = Number(window.prompt("移下多少格?","1"));
                                             var from = i;
                                             var to = i + shift;
                                             if (to >= this.items.length) {
                                               to = this.items.length - 1;
                                             }
                                             array_move(this.items, from, to);
                                             this.forceUpdate();
                                           }}
                                           onShiftOrder={(item) => {
                                            var to = Number(window.prompt("移至哪一格?","1"));
                                            var from = i;
                                            if (to>=this.items.length-1){
                                              to = this.items.length-1;
                                            }
                                            //console.log(to);
                                            //console.log(from);
                                            if (to!=from && to!=0){
                                              array_move(this.items, from, to);
                                            }
                                            this.forceUpdate();
                                          }}
                                           onShiftAlign={(item) => {                                             
                                            if (item._attributes.style=='msg'){
                                              switch (item._attributes.position){                                              
                                                case 'left':
                                                    item._attributes.position = 'right';
                                                break;
                                                /*case 'center':
                                                    item._attributes.position = 'right';
                                                break;*/
                                                case 'right':
                                                    item._attributes.position = 'left';
                                                break;                                              
                                              }
                                            }
                                            
                                            this.forceUpdate();
                                          }}
                            />
                        )
                      })
                    }
                    <div style={{height: 250}}/>
                  </div>
              ) : null
            }

          </div>


        </div>
    )
  }
}

